import _ from 'lodash';
import { useRouter } from 'next/router';
import { applyFilters } from '../../../utils/filters';
import { sortRoomTypes } from '../../../utils/sort';

const RoomTypesFilters = (props) => {
    const roomTypes = _.map(props.roomTypes, (roomType) => roomType);
    const { children, showNewFirst } = props;
    const router = useRouter();
    const rentalDurationTerm = _.get(router, 'query.term');
    const styleParam = _.get(router, 'query.style');
    const buildings = _.get(router, 'query.building');
    const guestCount = _.get(router, 'query.guestCount');
    const categories = _.get(router, 'query.category');
    const priceMin = _.get(router, 'query.priceMin');
    const priceMax = _.get(router, 'query.priceMax');
    const portfolioId = _.get(router, 'query.portfolioId');
    const newRoom = _.get(router, 'query.new');

    const filteredRoomTypes = applyFilters(
        roomTypes,
        rentalDurationTerm,
        styleParam,
        buildings,
        guestCount,
        categories,
        priceMin,
        priceMax,
        portfolioId,
        newRoom,
    );

    let sortedRoomTypes = filteredRoomTypes;
    if (styleParam === 'private_apartment' || styleParam === 'private_bedroom') {
        sortedRoomTypes = sortRoomTypes(filteredRoomTypes, 'numberAvailable', showNewFirst);
    } else if (styleParam === 'shared_female') {
        sortedRoomTypes = sortRoomTypes(
            filteredRoomTypes,
            'numberAvailableForFemales',
            showNewFirst,
        );
    } else if (styleParam === 'shared_male') {
        sortedRoomTypes = sortRoomTypes(filteredRoomTypes, 'numberAvailableForMales', showNewFirst);
    } else {
        sortedRoomTypes = sortRoomTypes(filteredRoomTypes, 'numberAvailable', showNewFirst);
    }
    return children(sortedRoomTypes);
};

export default RoomTypesFilters;
